import {Linking} from 'react-native';

export const useWebpage = () => {
  const open = (url: string) => Linking.openURL(url);
  return {
    open,
  };
};
